import * as React from "react"
import { Box } from "@chakra-ui/react"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { roomSelector } from "../../../../recoil/atoms/room"
import { Range, getTrackBackground } from "react-range"
import {
  playerPropsSelector,
  canDragSceenAtom
} from "../../../../recoil/atoms/player"
import { productOverlaySelector } from "../../../../recoil/atoms/product-overlay"
import { useBrowserType } from "../../../../hooks/useBrowserType"

interface BarProps {
  handleOnChange: any
  values: any
  showThumb?: boolean
}

export const BarPlayer: React.FC<BarProps> = ({
  handleOnChange,
  values,
  showThumb = true
}) => {
  const room = useRecoilValue(roomSelector)
  const setPlayerProps = useSetRecoilState(playerPropsSelector)
  const { isMobile } = useBrowserType()
  const { isOpenControlsMobile, isOpenControlDesktop, isEnabledToggleMobile } =
    useRecoilValue(playerPropsSelector)
  const setCanDragScreen = useSetRecoilState(canDragSceenAtom)

  const handleStartTouch = e => {
    setCanDragScreen(false)

    setPlayerProps({ isEnabledToggleMobile: false })
  }

  const handleEndTouch = e => {
    setCanDragScreen(true)
    setPlayerProps({ isEnabledToggleMobile: true })
  }

  const { isOpen } = useRecoilValue(productOverlaySelector)

  return (
    <>
      <Box pos="absolute" bottom="50px" left="0px" width="100%">
        <Box
          backgroundColor={room?.branding?.servicePanelElementBorder}
          position="absolute"
          left="0px"
          bottom="0px"
          zIndex={"-1"}
          width="12px"
          height="5px"
          borderLeftRadius={
            (isOpenControlDesktop && !isOpen) ||
            isOpenControlsMobile ||
            !isEnabledToggleMobile
              ? "0px"
              : "4px"
          }
        />
        <Range
          step={0.1}
          min={0}
          max={100}
          values={values}
          onChange={handleOnChange}
          renderTrack={({ props, children }) => (
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                height: "5px",
                display: "flex",
                width: "100%",
                zIndex: 1,
              }}
              onClick={e => e.stopPropagation()}
            >
              <div
                ref={props.ref}
                style={{
                  height: "5px",
                  width: "100%",
                  background: getTrackBackground({
                    values,
                    colors: [
                      room?.branding?.servicePanelElementBorder,
                      room?.branding.servicePanelElementBorderOffset
                    ],
                    min: 0,
                    max: 100
                  }),
                  alignSelf: "center"
                }}
              >
                {children}
              </div>
            </div>
          )}
          renderThumb={({ props }) =>
            showThumb && (
              <div
                {...props}
                onTouchStart={handleStartTouch}
                onTouchEnd={handleEndTouch}
                onFocus={e => e.target.blur()}
                style={{
                  ...props.style,
                  height: "12px",
                  width: "12px",
                  visibility: isOpen ? "hidden" : "visible",
                  padding: "0px 20px 20px 20px",
                  top: isOpen ? "-7.5px" : "7.5px"
                }}
              >
                {
                  <div
                    style={{
                      height: "12px",
                      width: "12px",
                      backgroundColor:
                        room?.branding?.servicePanelElementBorder,
                      transform: /* values[0] > 99
                        ? `translate(0px, -${isMobile ? 0.2 : 0}px)`
                        :  */ `translate(-12px, -${isMobile ? 0.1 : 0}px)`,
                      position: "absolute",
                      borderBottomLeftRadius: "0.2rem",
                      borderBottomRightRadius: "0.2rem"
                    }}
                  ></div>
                }
              </div>
            )
          }
        />
      </Box>
    </>
  )
}
